var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.304949 1.25879C0.0897571 1.03651 0.0897571 0.676105 0.30495 0.453822C0.520142 0.231539 0.868976 0.231539 1.08417 0.453822L5.85828 5.3854L10.6319 0.454315C10.8471 0.232024 11.196 0.232024 11.4111 0.454315C11.6263 0.676605 11.6263 1.03695 11.4111 1.25924L6.56476 6.26553C6.57462 6.32736 6.57458 6.39055 6.56463 6.45237L11.4111 11.4588C11.6263 11.6811 11.6263 12.0415 11.4111 12.2637C11.196 12.486 10.8471 12.486 10.6319 12.2637L5.85782 7.33216L1.08417 12.2632C0.868976 12.4855 0.520141 12.4855 0.304949 12.2632C0.0897566 12.041 0.0897566 11.6806 0.304949 11.4583L5.15134 6.45204C5.14147 6.3902 5.14152 6.32701 5.15147 6.26519L0.304949 1.25879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8a58896e938774090ab5b11f3f8fb07f.svg";
export { ForwardRef as ReactComponent };